module.exports = __webpack_public_path__ + "img/fat-free-oatmeal-cookies.22ccabd2.jpg";